import styled, { css } from 'styled-components';

interface TagProps {
  $selected?: boolean;
}

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const SelectContainer = styled.div`
  margin: ${({ theme }) => theme.spacing(4, 2, 3, 2)};
`;

export const Tag = styled.span<TagProps>`
  text-transform: uppercase;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.p3};
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.spacing(0.1)};

  background-color: ${({ theme }) => theme.colors.secondaryLightGrey};
  color: ${({ theme }) => theme.colors.primaryDark};

  ${({ $selected, theme }) =>
    $selected &&
    css`
      background-color: ${theme.colors.primaryDark};
      color: ${theme.colors.white};
    `}
`;
